import { Link } from 'react-router-dom'
import { AccountRecord } from '../../api/client'

type Props = {
    account: AccountRecord
}

export const AccountSettings = (props: Props) => {
    const { account } = props

    return (
        <div className="px-6 flex flex-row content-between">
            <Link
                to={`/account/${account.id}/settings`}
                className="font-semibold text-arwen-700 hover:text-arwen-800 inline-flex items-center"
            >
                Profile settings
            </Link>
        </div>
    )
}
